/**
 * Complete Authentic Hindi Translations for MyMenuBuddy Recipes (All 45 Dishes)
 */

export const STATE_HINDI_MAP = {
  "Tamil Nadu": "तमिलनाडु",
  "Tamil Nadu / South India": "तमिलनाडु / दक्षिण भारत",
  "Kerala": "केरल",
  "Andhra Pradesh": "आंध्र प्रदेश",
  "Karnataka": "कर्नाटक",
  "Punjab": "पंजाब",
  "Maharashtra": "महाराष्ट्र",
  "Delhi / Punjab": "दिल्ली / पंजाब",
  "North India": "उत्तर भारत",
  "Tamil Nadu / Kerala": "तमिलनाडु / केरल",
  "Indo-Chinese": "इंडो-चाइनीज",
  "West Bengal": "पश्चिम बंगाल",
  "Punjab / Delhi": "पंजाब / दिल्ली",
  "India Healthy": "स्वस्थ भारतीय",
  "Central Thailand": "थाईलैंड",
  "Kanto": "जापान",
  "Beirut Governorate": "मध्य पूर्व (लेबनानी)",
  "Central Mexico": "मैक्सिकन",
  "Campania": "इटली",
  "Lazio": "इटली",
  "Global": "अंतर्राष्ट्रीय",
  "Tamil Nadu / Telangana": "तमिलनाडु / तेलंगाना",
  "Kerala / Tamil Nadu": "केरल / तमिलनाडु"
};

export const CUISINE_HINDI_MAP = {
  'Tamil Nadu Breakfast': 'तमिलनाडु नाश्ता',
  'Tamil Nadu Traditional': 'तमिलनाडु पारंपरिक',
  'Temple Style Breakfast': 'मंदिर शैली नाश्ता',
  'South Indian Breakfast': 'दक्षिण भारतीय नाश्ता',
  'Kerala Syrian Christian': 'केरल पारंपरिक',
  'Andhra Breakfast': 'आंध्र नाश्ता',
  'Karnataka Tiffin': 'कर्नाटक टिफिन',
  'Punjabi Breakfast': 'पंजाबी नाश्ता',
  'Maharashtrian Breakfast': 'महाराष्ट्र नाश्ता',
  'Tamil Nadu Comfort Food': 'तमिलनाडु स्पेशल',
  'Kongunadu': 'कोंगुनाडु पारंपरिक',
  'Tirunelveli Traditional': 'तिरुनलवेली पारंपरिक',
  'Chettinad Non-Veg': 'चेट्टीनाड मांसाहारी',
  'Royal Biryani': 'शाही बिरयानी',
  'Coastal Seafood': 'तटीय समुद्री भोजन',
  'North Indian Dhaba': 'उत्तर भारतीय ढाबा शैली',
  'Punjabi Comfort Food': 'पंजाबी पारंपरिक',
  'Andhra Spicy': 'आंध्र मसालेदार',
  'North Indian Homestyle': 'उत्तर भारतीय घरेलू खाना',
  'Mughlai North Indian': 'मुगलई उत्तर भारतीय',
  'Street Tiffin Classic': 'स्ट्रीट टिफिन स्पेशल',
  'Italian Classic': 'इटालियन क्लासिक',
  'Italian Pasta': 'इटालियन पास्ता',
  'Indo-Chinese': 'इंडो-चाइनीज',
  'Indo-Chinese Non-Veg': 'इंडो-चाइनीज नॉन-वेज',
  'Thai Street Food': 'थाई स्ट्रीट फूड',
  'Japanese Ramen': 'जापानी रेमन',
  'Middle Eastern': 'मध्य पूर्वी व्यंजन',
  'Mumbai Street Food': 'मुंबई स्ट्रीट फूड',
  'Punjabi Street Food': 'पंजाबी स्ट्रीट फूड',
  'Mexican Traditional': 'मैक्सिकन पारंपरिक',
  'Evening Tea Snack': 'शाम का चाय नाश्ता',
  'Kanyakumari Coastal': 'कन्याकुमारी तटीय',
  'Kerala Seafood Classic': 'केरल समुद्री भोजन',
  'Kerala Non-Veg Breakfast': 'केरल मांसाहारी नाश्ता',
  'Kerala Traditional': 'केरल पारंपरिक',
  'Sadhya Classic': 'केरल सद्या दावत',
  'High Protein Dinner': 'उच्च प्रोटीन रात का खाना',
  'Temple Snack & Tea Time': 'मंदिर प्रसाद व नाश्ता',
  'Military Mess Classic': 'मिलिट्री मेस स्पेशल',
  'Wholesome Millet Classic': 'पौष्टिक मिलेट्स भोजन',
  'Fiber Rich Breakfast': 'फाइबर युक्त नाश्ता'
};

export const HINDI_RECIPES = {
  1: {
    meal_hi: "नरम इडली + सांभर + नारियल चटनी",
    desc_hi: "रुई जैसी फूली हुई नरम इडली, गरमा-गरम स्वादिष्ट दाल सांभर और ताज़ा नारियल की चटनी।",
    state_hi: "तमिलनाडु",
    dishes_hi: [
      {
        name_hi: "नरम स्टीम्ड इडली",
        ingredients_hi: [["इडली चावल", "2 कप"], ["धुली उड़द दाल", "1/2 कप"], ["मेथी दाना", "1 छोटा चम्मच"], ["नमक", "1 छोटा चम्मच"], ["पानी", "आवश्यकतानुसार"]],
        quick_hi: "चावल और दाल को अलग-अलग 4 घंटे भिगोएं|दाल को हल्का और चावल को दरदरा पीसें|रातभर 8-10 घंटे खमीर उठने दें|इडली के सांचे में 10 मिनट भाप में पकाएं"
      },
      {
        name_hi: "सब्जियों वाला सांभर",
        ingredients_hi: [["अरहर दाल", "1/2 कप"], ["मिक्स सब्जियां व छोटे प्याज", "1.5 कप"], ["टमाटर", "1 कटा हुआ"], ["इमली का रस", "2 चम्मच"], ["सांभर पाउडर", "1.5 चम्मच"], ["हल्दी व हींग", "1/4 चम्मच"], ["राई व कढ़ी पत्ता", "तड़के के लिए"], ["घी/तेल", "1 चम्मच"], ["नमक", "1 चम्मच"]],
        quick_hi: "दाल को हल्दी डालकर कुकर में अच्छी तरह उबालें|सब्जियों को इमली पानी, सांभर पाउडर और नमक के साथ पकाएं|उबली दाल मिलाकर 5 मिनट खदकाएं|घी में राई, हींग, कढ़ी पत्ता तड़काएं"
      },
      {
        name_hi: "नारियल की चटनी",
        ingredients_hi: [["कद्दूकस नारियल", "1 कप"], ["भुनी चना दाल", "2 चम्मच"], ["हरी मिर्च", "2"], ["अदरक", "छोटा टुकड़ा"], ["राई व कढ़ी पत्ता", "तड़के के लिए"], ["नमक", "1/2 चम्मच"]],
        quick_hi: "नारियल, चना दाल, हरी मिर्च, अदरक और नमक डालकर पीसें|गरम तेल में राई और कढ़ी पत्ते का तड़का लगाएं"
      }
    ]
  },
  2: {
    meal_hi: "कुरकुरा घी डोसा + सांभर + टमाटर चटनी",
    desc_hi: "सुनहरा, कुरकुरा घी डोसा, गरमा-गरम सांभर और चटपटी टमाटर प्याज की चटनी।",
    state_hi: "तमिलनाडु",
    dishes_hi: [
      {
        name_hi: "कुरकुरा घी डोसा",
        ingredients_hi: [["डोसा बैटर", "2 कप"], ["शुद्ध घी / तेल", "2 चम्मच"], ["पानी", "आवश्यकतानुसार"]],
        quick_hi: "गरम तवे पर बैटर को गोल फैलाएं|किनारों पर घी लगाएं|नीचे से सुनहरा व कुरकुरा होने पर पलट कर रोल करें"
      },
      {
        name_hi: "चटपटी टमाटर चटनी",
        ingredients_hi: [["टमाटर", "2 कटे हुए"], ["प्याज", "1 कटा हुआ"], ["लहसुन", "4 कलियां"], ["सूखी लाल मिर्च", "4"], ["राई व कढ़ी पत्ता", "तड़के के लिए"], ["तेल", "1.5 चम्मच"], ["नमक", "1/2 चम्मच"]],
        quick_hi: "प्याज, लहसुन, मिर्च और टमाटर को तेल में भूनें|ठंडा करके नमक डालकर पीसें|राई और कढ़ी पत्ते का तड़का लगाएं"
      }
    ]
  },
  3: {
    meal_hi: "वेन पोंगल + मेदू वड़ा + सांभर",
    desc_hi: "काली मिर्च, जीरा, काजू और शुद्ध घी की खुशबू से भरपूर वेन पोंगल और कुरकुरा मेदू वड़ा।",
    state_hi: "तमिलनाडु",
    dishes_hi: [
      {
        name_hi: "घी वेन पोंगल",
        ingredients_hi: [["चावल", "1 कप"], ["मूंग दाल", "1/2 कप भुनी हुई"], ["शुद्ध घी", "4 चम्मच"], ["काली मिर्च व जीरा", "1-1 चम्मच"], ["अदरक", "1 चम्मच बारीक कटा"], ["काजू", "12"], ["कढ़ी पत्ता व हींग", "स्वादानुसार"], ["नमक", "1.5 चम्मच"]],
        quick_hi: "चावल और भुनी दाल को 4.5 कप पानी में अच्छी तरह पकाएं|घी में काजू, काली मिर्च, जीरा, अदरक, हींग व कढ़ी पत्ता भूनें|गरम तड़का पोंगल में मिलाकर अच्छी तरह चलाएं"
      },
      {
        name_hi: "कुरकुरा मेदू वड़ा",
        ingredients_hi: [["उड़द दाल", "1 कप भीगी हुई"], ["हरी मिर्च व अदरक", "1-1 चम्मच"], ["काली मिर्च", "1 चम्मच"], ["कढ़ी पत्ता व हींग", "स्वादानुसार"], ["तेल", "तलने के लिए"], ["नमक", "1/2 चम्मच"]],
        quick_hi: "उड़द दाल को कम पानी में हल्का व गाढ़ा पीसें|मसाले मिलाकर फेंटें|बीच में छेद बनाकर गरम तेल में सुनहरा कुरकुरा तलें"
      }
    ]
  },
  4: {
    meal_hi: "फूली पूरी + आलू मसाला (पूरी भाजी)",
    desc_hi: "गरमा-गरम फूली हुई गेहूं की पूरियां और दक्षिण भारतीय होटल स्टाइल चटपटा आलू मसाला।",
    state_hi: "तमिलनाडु / दक्षिण भारत",
    dishes_hi: [
      {
        name_hi: "कुरकुरी फूली पूरियां",
        ingredients_hi: [["गेहूं का आटा", "2 कप"], ["सूजी", "2 चम्मच"], ["तेल", "तलने के लिए"], ["नमक", "1/2 चम्मच"], ["पानी", "गूंधने के लिए"]],
        quick_hi: "सख्त आटा गूंधें|छोटी लोइयां बेलें|गरम तेल में डालकर दबाते हुए फूलाएं और सुनहरा तलें"
      },
      {
        name_hi: "होटल स्टाइल आलू मसाला",
        ingredients_hi: [["उबले आलू", "4 मसले हुए"], ["प्याज", "2 पतले कटे"], ["हरी मिर्च व अदरक", "2 चम्मच"], ["बेसन", "1 चम्मच पानी में घुला"], ["हल्दी, राई, चना दाल", "तड़के के लिए"], ["तेल", "1.5 चम्मच"], ["नमक", "1 चम्मच"]],
        quick_hi: "राई, चना दाल, मिर्च और प्याज भूनें|हल्दी, आलू और पानी डालें|बेसन का घोल मिलाकर गाढ़ा होने तक पकाएं"
      }
    ]
  },
  5: {
    meal_hi: "केरल अप्पम + स्वादिष्ट वेज स्टू",
    desc_hi: "मुलायम किनारों वाला जालीदार केरल अप्पम और नारियल के दूध में पकी सब्जियों का हल्का मीठा स्टू।",
    state_hi: "केरल",
    dishes_hi: [
      {
        name_hi: "केरल पालप्पम",
        ingredients_hi: [["कच्चा चावल", "2 कप भीगा"], ["पके चावल", "1/2 कप"], ["कद्दूकस नारियल", "1/2 कप"], ["यीस्ट / नारियल पानी", "खमीर के लिए"], ["चीनी व नमक", "1-1 चम्मच"]],
        quick_hi: "चावल, नारियल और पके चावल पीसें|खमीर उठने दें|अप्पम चट्टी में बैटर डालकर गोल घुमाएं और ढककर पकाएं"
      },
      {
        name_hi: "नारियल दूध वेज स्टू",
        ingredients_hi: [["आलू, गाजर, बीन्स, मटर", "2 कप"], ["गाढ़ा व पतला नारियल दूध", "1 कप और 1.5 कप"], ["हरी मिर्च, अदरक, खड़े मसाले", "स्वादानुसार"], ["नारियल तेल", "1.5 चम्मच"], ["कढ़ी पत्ता व नमक", "स्वादानुसार"]],
        quick_hi: "खड़े मसाले, अदरक और मिर्च नारियल तेल में भूनें|सब्जियां पतले नारियल दूध में उबालें|गाढ़ा दूध और कढ़ी पत्ता डालकर धीमी आंच पर उतारें"
      }
    ]
  },
  6: {
    meal_hi: "आंध्र पेसरट्टू + अदरक की चटनी",
    desc_hi: "साबुत हरी मूंग दाल का प्रोटीन से भरपूर कुरकुरा डोसा और खट्टी-मीठी अल्लम (अदरक) चटनी।",
    state_hi: "आंध्र प्रदेश",
    dishes_hi: [
      {
        name_hi: "हरी मूंग पेसरट्टू",
        ingredients_hi: [["साबुत हरी मूंग दाल", "2 कप भीगी"], ["चावल", "2 चम्मच"], ["अदरक व हरी मिर्च", "2 चम्मच"], ["जीरा", "1 छोटा चम्मच"], ["कटा प्याज", "ऊपर डालने के लिए"], ["तेल", "सेंकने के लिए"], ["नमक", "1 चम्मच"]],
        quick_hi: "मूंग दाल, चावल, अदरक और मिर्च को बारीक पीसें|तवे पर डोसा फैलाएं, ऊपर प्याज व जीरा डालें|कुरकुरा होने तक सेकें"
      },
      {
        name_hi: "आंध्र अल्लम (अदरक) चटनी",
        ingredients_hi: [["ताज़ा अदरक", "2 चम्मच"], ["इमली का पल्प", "2 चम्मच"], ["गुड़", "1.5 चम्मच"], ["सूखी लाल मिर्च", "4"], ["राई व कढ़ी पत्ता", "तड़के के लिए"], ["नमक", "1/2 चम्मच"]],
        quick_hi: "मिर्च और अदरक को भूनें|इमली, गुड़ और नमक के साथ पीसें|राई का तड़का लगाएं"
      }
    ]
  },
  7: {
    meal_hi: "रवा उपमा + नारियल चटनी",
    desc_hi: "काजू, सब्जियों और शुद्ध घी के साथ भुनी सूजी का खिला-खिला और खुशबूदार पारंपरिक उपमा।",
    state_hi: "कर्नाटक",
    dishes_hi: [
      {
        name_hi: "कर्नाटक रवा उपमा",
        ingredients_hi: [["भुनी सूजी (रवा)", "1 कप"], ["पानी", "2.5 कप"], ["प्याज, गाजर, मटर", "1 कप"], ["अदरक व हरी मिर्च", "1 चम्मच"], ["काजू व राई", "तड़के के लिए"], ["घी / तेल", "2 चम्मच"], ["कढ़ी पत्ता व नमक", "स्वादानुसार"]],
        quick_hi: "सूजी को हल्का भूनें|घी में राई, काजू, मिर्च, अदरक व सब्जियां भूनें|पानी व नमक उबालें|सूजी डालकर लगातार चलाते हुए धीमी आंच पर पकाएं"
      }
    ]
  },
  8: {
    meal_hi: "आलू पराठा + ताज़ा दही + मक्खन",
    desc_hi: "चटपटे उबले आलू, हरी मिर्च, धनिए से भरा कुरकुरा सुनहरा पराठा, गाढ़े दही और सफ़ेद मक्खन के साथ।",
    state_hi: "पंजाब",
    dishes_hi: [
      {
        name_hi: "ढाबा स्टाइल आलू पराठा",
        ingredients_hi: [["गेहूं का आटा", "2 कप गूंधा हुआ"], ["उबले आलू", "4 मसले हुए"], ["हरी मिर्च, अदरक, धनिया", "बारीक कटा"], ["अमचूर, गरम मसाला, अजवाइन", "1-1 छोटा चम्मच"], ["मक्खन / घी", "सेंकने के लिए"], ["नमक", "1 चम्मच"]],
        quick_hi: "आलू में सारे मसाले मिलाएं|आटे की लोई में स्टफिंग भरकर बेलें|तवे पर घी लगाकर दोनों तरफ से सुनहरा व कुरकुरा सेकें"
      }
    ]
  },
  9: {
    meal_hi: "कांदा पोहा + कुरकुरी सेव + नींबू",
    desc_hi: "हल्दी, भुनी मूंगफली, प्याज और कढ़ी पत्ते के तड़के से बना हल्का, स्वादिष्ट और पौष्टिक नाश्ता।",
    state_hi: "महाराष्ट्र",
    dishes_hi: [
      {
        name_hi: "महाराष्ट्र कांदा पोहा",
        ingredients_hi: [["मोटा पोहा", "2 कप धोया व छाना हुआ"], ["प्याज", "1 बड़ा बारीक कटा"], ["कच्ची मूंगफली", "3 चम्मच"], ["हरी मिर्च, राई, कढ़ी पत्ता", "तड़के के लिए"], ["हल्दी", "1/2 चम्मच"], ["नींबू व धनिया", "गार्निश के लिए"], ["नमक", "1 चम्मच"]],
        quick_hi: "तेल में मूंगफली तलें, राई, मिर्च व प्याज भूनें|हल्दी, नमक और भीगा पोहा डालकर हल्के हाथ से मिलाएं|नींबू, हरा धनिया और सेव डालकर परोसें"
      }
    ]
  },
  10: {
    meal_hi: "सांभर चावल + आलू रोस्ट + पापड़",
    desc_hi: "दाल, सब्जियों और शुद्ध घी में पका तृप्तिकारक सांभर सादम और चटपटा मसालेदार आलू रोस्ट।",
    state_hi: "तमिलनाडु",
    dishes_hi: [
      {
        name_hi: "पारंपरिक सांभर सादम",
        ingredients_hi: [["चावल व अरहर दाल", "1 कप और 1/2 कप"], ["मिक्स सब्जियां व छोटे प्याज", "2 कप"], ["सांभर पाउडर", "2 चम्मच"], ["इमली का रस", "3 चम्मच"], ["शुद्ध घी", "3 चम्मच"], ["राई, हींग, कढ़ी पत्ता", "तड़के के लिए"], ["नमक", "1.5 चम्मच"]],
        quick_hi: "चावल, दाल, सब्जियां, सांभर मसाला, इमली और नमक कुकर में 4 सीटी तक उबालें|घी में राई, हींग, कढ़ी पत्ता तड़काकर मिलाएं"
      },
      {
        name_hi: "चटपटा आलू रोस्ट",
        ingredients_hi: [["आलू", "3 कटे हुए"], ["लाल मिर्च व धनिया पाउडर", "1-1 चम्मच"], ["हल्दी व सौंफ", "1/2 छोटा चम्मच"], ["तेल", "2 चम्मच"], ["नमक", "1 चम्मच"]],
        quick_hi: "तेल में सौंफ तड़काएं, आलू, मसाले और नमक डालकर धीमी आंच पर कुरकुरा लाल होने तक भूनें"
      }
    ]
  },
  11: {
    meal_hi: "रसम चावल + आलू फ्राई + पापड़",
    desc_hi: "काली मिर्च, जीरा, लहसुन और टमाटर का पाचक रसम चावल, कुरकुरे आलू फ्राई और पापड़ के साथ।",
    state_hi: "तमिलनाडु",
    dishes_hi: [
      {
        name_hi: "काली मिर्च लहसुन रसम",
        ingredients_hi: [["टमाटर", "2 मसले हुए"], ["इमली पानी", "1 कप"], ["लहसुन, काली मिर्च, जीरा", "कुटा हुआ 2 चम्मच"], ["हल्दी व हींग", "1/4 चम्मच"], ["घी, राई, कढ़ी पत्ता", "तड़के के लिए"], ["हरा धनिया", "मुट्ठीभर"], ["नमक", "1 चम्मच"]],
        quick_hi: "इमली पानी में टमाटर, कुटा मसाला, हल्दी, हींग और नमक उबालें|झाग आते ही घी में राई, कढ़ी पत्ता तड़काएं और धनिया डालकर ढक दें"
      }
    ]
  },
  12: {
    meal_hi: "दही चावल (थाईर सादम) + आलू फ्राई + आम का अचार",
    desc_hi: "दूध और ताज़े दही में पका क्रीमी दही चावल, राई, अदरक, हरी मिर्च के तड़के और आलू फ्राई के साथ।",
    state_hi: "तमिलनाडु / दक्षिण भारत",
    dishes_hi: [
      {
        name_hi: "क्रीमी दक्षिण भारतीय दही चावल",
        ingredients_hi: [["नरम पका चावल", "2 कप"], ["ताज़ा दही व दूध", "1 कप और 1/2 कप"], ["अदरक, हरी मिर्च, कढ़ी पत्ता", "तड़के के लिए"], ["राई, उड़द दाल, हींग", "1-1 छोटा चम्मच"], ["अनार के दाने / धनिया", "सजाने के लिए"], ["नमक", "1 चम्मच"]],
        quick_hi: "चावल को मैश करके दही, दूध और नमक मिलाएं|तेल में राई, उड़द दाल, हींग, अदरक, मिर्च, कढ़ी पत्ता तड़काएं|अनार के दानों से सजाएं"
      }
    ]
  },
  13: {
    meal_hi: "कोंगु दाल चावल (अरिसी परुप्पु सादम) + आलू फ्राई",
    desc_hi: "तमिलनाडु के कोंगुनाडु की मशहूर एक-पॉट डिश—चावल और तुवर दाल, लहसुन, प्याज व घी के साथ।",
    state_hi: "तमिलनाडु",
    dishes_hi: [
      {
        name_hi: "कोंगुनाडु दाल चावल",
        ingredients_hi: [["चावल", "1 कप"], ["तुवर दाल", "1/2 कप"], ["छोटे प्याज व लहसुन", "15"], ["टमाटर", "1"], ["सांभर पाउडर व हल्दी", "1 चम्मच"], ["घी व तेल", "2 चम्मच"], ["नमक", "1 चम्मच"]],
        quick_hi: "कुकर में तेल गर्म करके प्याज, लहसुन, टमाटर और मसाले भूनें|चावल, दाल और पानी डालकर 3 सीटी तक पकाएं|ऊपर से घी डालें"
      }
    ]
  },
  14: {
    meal_hi: "नेल्लई सोधी (नारियल दूध स्टू) + चावल + आलू रोस्ट",
    desc_hi: "तिरुनेलवेली की पारंपरिक शादी स्पेशल डिश—गाढ़े नारियल दूध, मूंग दाल और सब्जियों का शाही स्टू।",
    state_hi: "तमिलनाडु",
    dishes_hi: [
      {
        name_hi: "तिरुनेलवेली सोधी",
        ingredients_hi: [["मूंग दाल", "1/4 कप उबली"], ["सब्जियां (ड्रमस्टिक, गाजर, आलू)", "1.5 कप"], ["गाढ़ा व पतला नारियल दूध", "1 कप और 2 कप"], ["नींबू का रस", "1 बड़ा चम्मच"], ["हरी मिर्च व अदरक", "स्वादानुसार"], ["नमक", "1 चम्मच"]],
        quick_hi: "सब्जियों को पतले नारियल दूध में पकाएं|उबली मूंग दाल और गाढ़ा नारियल दूध मिलाएं|उतारकर नींबू का रस और तड़का लगाएं"
      }
    ]
  },
  15: {
    meal_hi: "चेट्टीनाड काली मिर्च चिकन + रसम चावल + आलू रोस्ट",
    desc_hi: "ताज़ी कुटी काली मिर्च, सौंफ और चेट्टीनाड मसालों में भुना मसालेदार चिकन, रसम चावल के साथ।",
    state_hi: "तमिलनाडु",
    dishes_hi: [
      {
        name_hi: "चेट्टीनाड पेपर चिकन रोस्ट",
        ingredients_hi: [["चिकन", "500 ग्राम"], ["काली मिर्च व सौंफ", "कुटा हुआ 2 चम्मच"], ["छोटे प्याज व लहसुन", "1 कप"], ["कढ़ी पत्ता", "खूब सारा"], ["तेल", "2 चम्मच"], ["नमक व हल्दी", "स्वादानुसार"]],
        quick_hi: "तेल में प्याज, लहसुन, कढ़ी पत्ता भूनें|चिकन और मसाले डालकर बिना पानी धीमी आंच पर रोस्ट करें|काली मिर्च डालकर सूखा भूनें"
      }
    ]
  },
  16: {
    meal_hi: "स्वादिष्ट चिकन बिरयानी + प्याज रायता + बैंगन सालन",
    desc_hi: "साबुत मसालों, पुदीने और केसर से धीमी आंच पर दम लगी खुशबूदार चिकन बिरयानी, ठंडे रायते के साथ।",
    state_hi: "तमिलनाडु / तेलंगाना",
    dishes_hi: [
      {
        name_hi: "दम चिकन बिरयानी",
        ingredients_hi: [["बासमती / जीरा सांबा चावल", "2 कप"], ["चिकन", "500 ग्राम मैरीनेट किया"], ["प्याज", "2 लच्छेदार तले"], ["दही, अदरक-लहसुन पेस्ट", "2-2 चम्मच"], ["बिरयानी मसाला, पुदीना, धनिया", "मुट्ठीभर"], ["घी व केसर दूध", "स्वादानुसार"], ["नमक", "1.5 चम्मच"]],
        quick_hi: "चावल को 70% पकाएं|मैरीनेट चिकन की परत बिछाएं, ऊपर चावल, तला प्याज, पुदीना, घी व केसर डालें|20 मिनट धीमी आंच पर दम दें"
      }
    ]
  },
  17: {
    meal_hi: "दक्षिण भारतीय मछली करी + उबले चावल + फिश फ्राई",
    desc_hi: "इमली, टमाटर और ताज़ा पिसे मसालों में पकी चटपटी तीखी मछली करी और कुरकुरी फिश फ्राई।",
    state_hi: "तमिलनाडु",
    dishes_hi: [
      {
        name_hi: "गांव की मछली करी (मीन कुलंबू)",
        ingredients_hi: [["मछली के टुकड़े", "500 ग्राम"], ["इमली का गाढ़ा रस", "1/2 कप"], ["छोटे प्याज, लहसुन, टमाटर", "1.5 कप"], ["मछली मसाला पाउडर", "2 चम्मच"], ["मेथी दाना व राई", "तड़के के लिए"], ["तिल का तेल", "3 चम्मच"], ["नमक", "1 चम्मच"]],
        quick_hi: "मिट्टी के बर्तन में तेल गर्म करके मेथी, प्याज, लहसुन भूनें|इमली पानी, मसाले और नमक डालकर खदकाएं|मछली डालकर 7 मिनट धीमी आंच पर पकाएं"
      }
    ]
  },
  18: {
    meal_hi: "दाल तड़का + जीरा राइस + आलू गोभी",
    desc_hi: "देसी घी, लहसुन, जीरे और सूखी लाल मिर्च के तड़के वाली पीली दाल, खुशबूदार जीरा राइस के साथ।",
    state_hi: "दिल्ली / पंजाब",
    dishes_hi: [
      {
        name_hi: "ढाबा स्टाइल दाल तड़का",
        ingredients_hi: [["अरहर व मूंग दाल", "1 कप"], ["प्याज, टमाटर, लहसुन, अदरक", "बारीक कटे"], ["देसी घी", "2 चम्मच"], ["जीरा, हींग, सूखी लाल मिर्च", "तड़के के लिए"], ["कसूरी मेथी व हरा धनिया", "स्वादानुसार"], ["नमक व हल्दी", "1-1 छोटा चम्मच"]],
        quick_hi: "दाल को हल्दी-नमक के साथ उबालें|कड़ाही में घी गर्म करके प्याज, टमाटर भूनें|दाल मिलाएं|ऊपर से लहसुन, जीरा, लाल मिर्च का तड़का लगाएं"
      }
    ]
  },
  19: {
    meal_hi: "पंजाबी राजमा चावल + कचुम्बर सलाद",
    desc_hi: "मक्खन, अदरक और खुशबूदार मसालों में धीमी आंच पर पके गाढ़े पंजाबी राजमा, खिले-खिले बासमती चावल के साथ।",
    state_hi: "पंजाब",
    dishes_hi: [
      {
        name_hi: "पंजाबी मसाला राजमा",
        ingredients_hi: [["चित्रा राजमा", "1 कप भीगे हुए"], ["प्याज, टमाटर प्यूरी", "1.5 कप"], ["अदरक-लहसुन पेस्ट", "1 बड़ा चम्मच"], ["राजमा मसाला, गरम मसाला", "1-1 चम्मच"], ["मक्खन / घी", "2 चम्मच"], ["हरा धनिया", "सजाने के लिए"], ["नमक", "1 चम्मच"]],
        quick_hi: "राजमा को खड़े मसालों के साथ नरम उबालें|प्याज, टमाटर प्यूरी और मसाले भूनें|राजमा डालकर धीमी आंच पर गाढ़ा होने तक खदकाएं"
      }
    ]
  },
  20: {
    meal_hi: "आंध्र स्पाइसी चिकन करी + चावल",
    desc_hi: "आंध्र प्रदेश की मशहूर तीखी और चटपटी चिकन करी, भुने मसालों और धनिए की खुशबू के साथ।",
    state_hi: "आंध्र प्रदेश",
    dishes_hi: [
      {
        name_hi: "आंध्र कोडी कुरा (चिकन करी)",
        ingredients_hi: [["चिकन", "500 ग्राम"], ["प्याज, हरी मिर्च, अदरक-लहसुन", "1.5 कप"], ["खसखस, नारियल व साबुत मसाले", "पिसे हुए 2 चम्मच"], ["लाल मिर्च व धनिया पाउडर", "1-1 चम्मच"], ["तेल", "2 चम्मच"], ["नमक", "1 चम्मच"]],
        quick_hi: "प्याज और अदरक-लहसुन भूनें|चिकन और पिसे मसाले डालकर भूनें|पानी डालकर गाढ़ी तरी बनने तक पकाएं"
      }
    ]
  },
  21: {
    meal_hi: "नरम चपाती + पनीर बटर मसाला",
    desc_hi: "मखमली टमाटर-काजू की ग्रेवी में पके मलाईदार पनीर के टुकड़े, फुल्का चपाती के साथ।",
    state_hi: "उत्तर भारत",
    dishes_hi: [
      {
        name_hi: "रेस्टोरेंट स्टाइल पनीर बटर मसाला",
        ingredients_hi: [["पनीर क्यूब्स", "200 ग्राम"], ["टमाटर व काजू प्यूरी", "1.5 कप"], ["मक्खन व ताज़ी क्रीम", "2-2 चम्मच"], ["कसूरी मेथी, कश्मीरी मिर्च, गरम मसाला", "1-1 चम्मच"], ["अदरक-लहसुन पेस्ट", "1 चम्मच"], ["नमक", "1 चम्मच"]],
        quick_hi: "मक्खन में अदरक-लहसुन और टमाटर-काजू प्यूरी भूनें|मसाले, क्रीम और पनीर क्यूब्स मिलाएं|कसूरी मेथी डालकर 3 मिनट पकाएं"
      }
    ]
  },
  22: {
    meal_hi: "बटर चिकन + गार्लिक बटर नान + जीरा राइस",
    desc_hi: "तंदूरी चिकन के टुकड़े, मखमली मखनी ग्रेवी, ताज़ी क्रीम और गार्लिक नान के साथ शाही भोजन।",
    state_hi: "दिल्ली / पंजाब",
    dishes_hi: [
      {
        name_hi: "मुगलई बटर चिकन",
        ingredients_hi: [["तंदूरी चिकन टिक्का", "400 ग्राम"], ["मखनी टमाटर प्यूरी", "2 कप"], ["मक्खन व क्रीम", "3-3 चम्मच"], ["शहद व कसूरी मेथी", "1-1 छोटा चम्मच"], ["कश्मीरी लाल मिर्च पाउडर", "1 चम्मच"], ["नमक", "1 चम्मच"]],
        quick_hi: "मक्खन में टमाटर प्यूरी और मसाले धीमी आंच पर भूनें|क्रीम, कसूरी मेथी और शहद मिलाएं|चिकन टिक्का डालकर 5 मिनट पकाएं"
      }
    ]
  },
  23: {
    meal_hi: "मालाबार परोटा + चिकन सालना / वेज कुरमा",
    desc_hi: "केरल का लच्छेदार, कुरकुरा और मुलायम परोटा, नारियल-खसखस की खुशबूदार सालना ग्रेवी के साथ।",
    state_hi: "तमिलनाडु / केरल",
    dishes_hi: [
      {
        name_hi: "लच्छेदार मालाबार परोटा",
        ingredients_hi: [["मैदा / आटा", "2 कप"], ["तेल / घी", "मोयन व सेंकने के लिए"], ["नमक व चीनी", "1/2 छोटा चम्मच"], ["पानी", "गूंधने के लिए"]],
        quick_hi: "मुलायम आटा गूंधकर तेल लगाएं|पतली परत खींचकर रोल करें|तवे पर दोनों तरफ सुनहरा सेकें और हाथों से थपथपाकर लच्छे खोलें"
      }
    ]
  },
  24: {
    meal_hi: "चीज़ मार्गेरीटा पिज्जा + गार्लिक ब्रेड",
    desc_hi: "हाथ से गूंथे क्रस्ट पर ताज़ा टमाटर सॉस, मोज़ेरेला चीज़ और तुलसी के पत्तों से बेक किया हुआ पिज्जा।",
    state_hi: "इटली",
    dishes_hi: [
      {
        name_hi: "क्लासिक मार्गेरीटा पिज्जा",
        ingredients_hi: [["पिज्जा बेस", "1"], ["पिज्जा सॉस", "3 चम्मच"], ["मोज़ेरेला चीज़", "1 कप कद्दूकस"], ["ताज़ा बेसिल (तुलसी)", "पत्ते"], ["ऑलिव ऑयल व ऑरिगेनो", "छिड़कने के लिए"]],
        quick_hi: "बेस पर सॉस फैलाएं|खूब सारा चीज़ और बेसिल डालें|ओवन में 220°C पर चीज़ पिघलने तक बेक करें"
      }
    ]
  },
  25: {
    meal_hi: "व्हाइट सॉस पास्ता (क्रीमी अल्फ्रेडो) + गार्लिक टोस्ट",
    desc_hi: "मक्खन, क्रीम और परमेसन चीज़ की गाढ़ी व्हाइट सॉस में पका पास्ता, कुरकुरे गार्लिक टोस्ट के साथ।",
    state_hi: "इटली",
    dishes_hi: [
      {
        name_hi: "क्रीमी व्हाइट सॉस पेन्ने पास्ता",
        ingredients_hi: [["पेन्ने पास्ता", "2 कप उबला"], ["मक्खन व मैदा", "2-2 चम्मच"], ["दूध", "1.5 कप"], ["चीज़ व क्रीम", "1/2 कप"], ["काली मिर्च, ऑरिगेनो, चिली फ्लेक्स", "1-1 छोटा चम्मच"], ["नमक", "स्वादानुसार"]],
        quick_hi: "मक्खन में मैदा भूनें, धीरे-धीरे दूध मिलाकर गाढ़ी सॉस बनाएं|चीज़, मसाले और उबला पास्ता मिलाएं"
      }
    ]
  },
  26: {
    meal_hi: "वेज फ्राइड राइस + गोभी मंचूरियन",
    desc_hi: "तेज आंच पर वोक में तली सब्जियों वाला फ्राइड राइस और चटपटी कुरकुरी गोभी मंचूरियन।",
    state_hi: "इंडो-चाइनीज",
    dishes_hi: [
      {
        name_hi: "चाइनीज वेज फ्राइड राइस",
        ingredients_hi: [["पके बासमती चावल", "3 कप ठंडे"], ["गाजर, बीन्स, पत्तागोभी, शिमला मिर्च", "1.5 कप बारीक कटी"], ["सोया सॉस, सिरका", "1-1 बड़ा चम्मच"], ["लहसुन व स्प्रिंग अनियन", "खूब सारा"], ["काली मिर्च व नमक", "स्वादानुसार"]],
        quick_hi: "वोक में तेज आंच पर लहसुन और सब्जियां 2 मिनट भूनें|चावल, सॉस और काली मिर्च डालकर टॉस करें"
      }
    ]
  },
  27: {
    meal_hi: "चिली चिकन + वेज हक्का नूडल्स",
    desc_hi: "सोया, चिली सॉस और शिमला मिर्च में लिपटा क्रिस्पी चिकन, वेज हक्का नूडल्स के साथ।",
    state_hi: "पश्चिम बंगाल",
    dishes_hi: [
      {
        name_hi: "कोलकाता स्टाइल चिली चिकन",
        ingredients_hi: [["चिकन टुकड़े", "300 ग्राम कॉर्नफ्लोर में तले"], ["शिमला मिर्च व प्याज", "क्यूब्स में कटे"], ["सोया सॉस, ग्रीन चिली सॉस", "1-1 बड़ा चम्मच"], ["अदरक, लहसुन, हरी मिर्च", "बारीक कटी"], ["काली मिर्च व नमक", "स्वादानुसार"]],
        quick_hi: "लहसुन, मिर्च, प्याज व शिमला मिर्च भूनें|सॉस और तला चिकन डालकर तेज आंच पर टॉस करें"
      }
    ]
  },
  28: {
    meal_hi: "थाई पैड थाई नूडल्स + मूंगफली",
    desc_hi: "इमली, पाम शुगर और मूंगफली की खट्टी-मीठी-तीखी थाई राइस नूडल्स।",
    state_hi: "थाईलैंड",
    dishes_hi: [
      {
        name_hi: "पारंपरिक पैड थाई",
        ingredients_hi: [["फ्लैट राइस नूडल्स", "200 ग्राम"], ["टोफू / सब्जियां", "1 कप"], ["इमली सॉस, सोया सॉस, गुड़", "2-2 चम्मच"], ["भुनी कुटी मूंगफली व नींबू", "सजाने के लिए"]],
        quick_hi: "नूडल्स उबालें|वोक में टोफू व सब्जियां भूनें|नूडल्स और पैड थाई सॉस डालकर टॉस करें|मूंगफली बुरकें"
      }
    ]
  },
  29: {
    meal_hi: "जापानी रेमन नूडल बाउल (अंडे के साथ)",
    desc_hi: "खुशबूदार सोया-मिसो ब्रोथ, उबले रेमन नूडल्स, सीजन्ड अंडा और हरी प्याज का संपूर्ण सूप बाउल।",
    state_hi: "जापान",
    dishes_hi: [
      {
        name_hi: "जापानी रेमन सूप बाउल",
        ingredients_hi: [["रेमन नूडल्स", "2 पैकेट"], ["सब्जी / चिकन ब्रोथ", "3 कप"], ["सोया सॉस, तिल का तेल", "1-1 बड़ा चम्मच"], ["उबला अंडा, कॉर्न, मशरूम, स्प्रिंग अनियन", "टॉपिंग"]],
        quick_hi: "ब्रोथ में सोया सॉस और मसाले उबालें|नूडल्स पकाकर बाउल में डालें, ऊपर गरम ब्रोथ और टॉपिंग्स सजाएं"
      }
    ]
  },
  30: {
    meal_hi: "फलाफेल पिटा पॉकेट + क्रीमी हुमुस",
    desc_hi: "काबुली चने के कुरकुरे फलाफेल, मुलायम पिटा ब्रेड, क्रीमी ताहिनी हुमुस और ताज़ी सलाद।",
    state_hi: "मध्य पूर्व (लेबनानी)",
    dishes_hi: [
      {
        name_hi: "कुरकुरा फलाफेल",
        ingredients_hi: [["भीगे काबुली चने", "1 कप"], ["धनिया, पार्सले, लहसुन", "बारीक पिसा"], ["जीरा, धनिया पाउडर", "1-1 छोटा चम्मच"], ["तेल", "तलने के लिए"], ["नमक", "1 छोटा चम्मच"]],
        quick_hi: "चने और जड़ी-बूटियों को दरदरा पीसें|टिक्की बनाकर गरम तेल में कुरकुरा सुनहरा तलें"
      }
    ]
  },
  31: {
    meal_hi: "मुंबई पाव भाजी + बटर टोस्टेड पाव",
    desc_hi: "मक्खन और पाव भाजी मसाले में मैश की हुई मिलीजुली सब्जियां, बटर में सिके पाव और नींबू के साथ।",
    state_hi: "महाराष्ट्र",
    dishes_hi: [
      {
        name_hi: "मुंबई चौपाटी पाव भाजी",
        ingredients_hi: [["उबली सब्जियां (आलू, फूलगोभी, मटर)", "3 कप मैश की"], ["टमाटर व प्याज", "2 कप"], ["पाव भाजी मसाला", "2 बड़े चम्मच"], ["खूब सारा अमूल मक्खन", "3 बड़े चम्मच"], ["कश्मीरी मिर्च व नींबू", "स्वादानुसार"]],
        quick_hi: "तवे पर मक्खन में प्याज, टमाटर और मसाला भूनें|मैश सब्जियां और पानी डालकर घोंटें|मक्खन डालकर पाव के साथ परोसें"
      }
    ]
  },
  32: {
    meal_hi: "पंजाबी छोले भटूरे + तली हरी मिर्च",
    desc_hi: "काले भुने मसालों वाले चटपटे पिंडी छोले और फूले-फूले कुरकुरे भटूरे, प्याज व मिर्च के साथ।",
    state_hi: "पंजाब / दिल्ली",
    dishes_hi: [
      {
        name_hi: "अमृतसरी पिंडी छोले",
        ingredients_hi: [["काबुली चने", "2 कप चाय पत्ती के पानी में उबले"], ["अनारदाना, छोले मसाला, अमचूर", "1-1 चम्मच"], ["अदरक के लच्छे व हरी मिर्च", "सजाने के लिए"], ["देसी घी", "तड़के के लिए"], ["नमक", "1 चम्मच"]],
        quick_hi: "उबले छोलों पर सूखे मसाले डालें|गरम घी में हींग, अजवाइन, अदरक का तड़का डालकर धीमी आंच पर गाढ़ा पकाएं"
      }
    ]
  },
  33: {
    meal_hi: "मैक्सिकन चीज़ी टैकोस + गुआकामोल + सालसा",
    desc_hi: "कुरकुरे कॉर्न टॉर्टिला शैल में राजमा, चीज़, ताज़ा टमाटर साल्सा और एवोकाडो गुआकामोल।",
    state_hi: "मैक्सिकन",
    dishes_hi: [
      {
        name_hi: "मैक्सिकन बीन्स टैकोस",
        ingredients_hi: [["टैको शेल्स", "4"], ["मैश बीन्स / राजमा", "1 कप"], ["टमाटर सालसा व चीज़", "1 कप"], ["गुआकामोल", "1/2 कप"]],
        quick_hi: "टैको शैल में बीन्स भरें, ऊपर सालसा, गुआकामोल और चीज़ डालकर परोसें"
      }
    ]
  },
  34: {
    meal_hi: "कुरकुरे प्याज पकोड़े + गरमा-गरम मसाला चाय",
    desc_hi: "बेसन, हरी मिर्च, धनिए और कढ़ी पत्ते से बने कुरकुरे प्याज के पकोड़े, इलायची-अदरक चाय के साथ।",
    state_hi: "तमिलनाडु / दक्षिण भारत",
    dishes_hi: [
      {
        name_hi: "कुरकुरे कांदा भजिया (पकोड़े)",
        ingredients_hi: [["लच्छेदार प्याज", "3"], ["बेसन व चावल का आटा", "1 कप और 2 चम्मच"], ["हरी मिर्च, अदरक, कढ़ी पत्ता", "बारीक कटा"], ["अजवाइन व लाल मिर्च", "1-1 छोटा चम्मच"], ["तेल", "तलने के लिए"], ["नमक", "1 चम्मच"]],
        quick_hi: "प्याज में नमक व मसाले मिलाकर पानी छूटने दें|बेसन और चावल का आटा मिलाकर बिना अतिरिक्त पानी गरम तेल में कुरकुरा तलें"
      }
    ]
  },
  35: {
    meal_hi: "कन्याकुमारी नारियल मछली करी + मट्टा चावल",
    desc_hi: "ताज़ा नारियल, जीरा और हरी मिर्च के पेस्ट में पकी खट्टी-तीखी कन्याकुमारी स्पेशल मछली करी।",
    state_hi: "तमिलनाडु / केरल",
    dishes_hi: [
      {
        name_hi: "कन्याकुमारी नारियल मछली करी",
        ingredients_hi: [["मछली", "500 ग्राम"], ["पिसा नारियल व जीरा", "1 कप"], ["कुडमपुली (मालाबार इमली)", "3 टुकड़े"], ["हरी मिर्च, हल्दी, करी पत्ता", "स्वादानुसार"], ["नारियल तेल", "2 चम्मच"]],
        quick_hi: "पिसा नारियल, कुडमपुली और पानी उबालें|मछली डालकर धीमी आंच पर पकाएं|कच्चा नारियल तेल और कढ़ी पत्ता डालें"
      }
    ]
  },
  36: {
    meal_hi: "केरल मीन पोलिचाथु (केले के पत्ते में मछली) + चावल",
    desc_hi: "मसालेदार प्याज-टमाटर की चटनी में लिपटी मछली, केले के पत्ते में लपेटकर तवे पर भुनी हुई।",
    state_hi: "केरल",
    dishes_hi: [
      {
        name_hi: "केरल स्टाइल मीन पोलिचाथु",
        ingredients_hi: [["पूरी मछली (पॉम्फ्रेट/करीमीन)", "1 मैरीनेट"], ["प्याज, अदरक, लहसुन, टमाटर", "मसाला भुना"], ["केले का पत्ता", "लपेटने के लिए"], ["नारियल तेल", "सेंकने के लिए"]],
        quick_hi: "केले के पत्ते पर भुना मसाला और मछली रखें|पत्ता धागे से बांधकर तवे पर धीमी आंच पर दोनों तरफ से सेकें"
      }
    ]
  },
  37: {
    meal_hi: "केरल अप्पम + स्वादिष्ट वेज स्टू",
    desc_hi: "मुलायम किनारों वाला जालीदार केरल अप्पम और नारियल के दूध में पकी सब्जियों का हल्का मीठा स्टू।",
    state_hi: "केरल",
    dishes_hi: [
      {
        name_hi: "केरल पालप्पम व स्टू",
        ingredients_hi: [["चावल का बैटर", "2 कप"], ["सब्जियां व नारियल दूध", "2 कप"], ["खड़े मसाले", "स्वादानुसार"]],
        quick_hi: "अप्पम पैन में अप्पम बनाएं और ताज़ा नारियल दूध वेज स्टू के साथ परोसें"
      }
    ]
  },
  38: {
    meal_hi: "केरल अप्पम + मालाबार अंडा रोस्ट",
    desc_hi: "मसालेदार भूने प्याज और टमाटर की गाढ़ी ग्रेवी में भुना उबला अंडा, मुलायम अप्पम के साथ।",
    state_hi: "केरल / तमिलनाडु",
    dishes_hi: [
      {
        name_hi: "मालाबार एग रोस्ट",
        ingredients_hi: [["उबले अंडे", "4 चीरे लगे"], ["लच्छेदार प्याज", "3"], ["टमाटर", "2"], ["गरम मसाला, धनिया, मिर्च", "1-1 चम्मच"], ["नारियल तेल व कढ़ी पत्ता", "स्वादानुसार"]],
        quick_hi: "प्याज को भूरा होने तक भूनें|मसाले और टमाटर डालकर तेल छूटने तक पकाएं|अंडे डालकर गाढ़ी ग्रेवी में लपेटें"
      }
    ]
  },
  39: {
    meal_hi: "पुट्टू + कडाला करी (चना करी) + पापड़",
    desc_hi: "भाप में पका चावल और नारियल का पुट्टू, भुने नारियल की गाढ़ी ग्रेवी वाली काले चने की करी के साथ।",
    state_hi: "केरल / तमिलनाडु",
    dishes_hi: [
      {
        name_hi: "केरल पुट्टू व कडाला करी",
        ingredients_hi: [["पुट्टू आटा (चावल का आटा)", "2 कप"], ["कद्दूकस नारियल", "1 कप"], ["उबले काले चने", "1.5 कप"], ["भुना पिसा नारियल मसाला", "1/2 कप"], ["नारियल तेल व कढ़ी पत्ता", "तड़के के लिए"]],
        quick_hi: "आटे में पानी छिड़ककर नम करें|पुट्टू मेकर में नारियल और आटा भरकर भाप दें|काले चने को नारियल ग्रेवी में खदकाएं"
      }
    ]
  },
  40: {
    meal_hi: "केरल अवियल + लाल चावल + मोरु करी",
    desc_hi: "कद्दू, सहजन, बीन्स, गाजर का नारियल-जीरा और ताज़े दही में पका पारंपरिक केरल अवियल।",
    state_hi: "केरल / तमिलनाडु",
    dishes_hi: [
      {
        name_hi: "पारंपरिक केरल अवियल",
        ingredients_hi: [["लंबी कटी मिक्स सब्जियां", "3 कप"], ["नारियल, जीरा, हरी मिर्च", "दरदरा पिसा 1 कप"], ["ताज़ा गाढ़ा दही", "1/2 कप"], ["कच्चा नारियल तेल व कढ़ी पत्ता", "तड़के के लिए"], ["नमक", "1 छोटा चम्मच"]],
        quick_hi: "सब्जियों को थोड़े पानी और हल्दी में भाप दें|पिसा नारियल मिलाकर 2 मिनट पकाएं|दही, कच्चा नारियल तेल और कढ़ी पत्ता डालकर उतारें"
      }
    ]
  },
  41: {
    meal_hi: "पनीर भुर्जी + गेहूं के फुल्के",
    desc_hi: "कद्दूकस या मसला हुआ ताज़ा पनीर, प्याज, टमाटर, हरी मिर्च और मक्खन के साथ झटपट तैयार।",
    state_hi: "उत्तर भारत",
    dishes_hi: [
      {
        name_hi: "मसालेदार पनीर भुर्जी",
        ingredients_hi: [["ताज़ा पनीर", "250 ग्राम मसला हुआ"], ["प्याज, टमाटर, शिमला मिर्च", "बारीक कटी"], ["हरी मिर्च व अदरक", "1-1 बड़ा चम्मच"], ["हल्दी, पाव भाजी मसाला, धनिया", "1-1 छोटा चम्मच"], ["मक्खन / घी", "2 चम्मच"], ["नमक", "1 छोटा चम्मच"]],
        quick_hi: "मक्खन में जीरा, प्याज, अदरक व मिर्च भूनें|टमाटर और मसाले डालकर भूनें|पनीर मिलाकर 2 मिनट टॉस करें और धनिया डालें"
      }
    ]
  },
  42: {
    meal_hi: "चना सुंडल + इलायची मसाला चाय",
    desc_hi: "उबले सफेद या काले चने, कद्दूकस नारियल, हींग और राई-कढ़ी पत्ते के तड़के वाला मंदिर स्टाइल सुंडल।",
    state_hi: "तमिलनाडु",
    dishes_hi: [
      {
        name_hi: "मंदिर स्टाइल चना सुंडल",
        ingredients_hi: [["उबले सफेद काबुली चने", "2 कप"], ["कद्दूकस ताज़ा नारियल", "1/2 कप"], ["हरी मिर्च व अदरक", "बारीक कटी"], ["राई, उड़द दाल, हींग", "1-1 छोटा चम्मच"], ["नारियल तेल व कढ़ी पत्ता", "तड़के के लिए"], ["नमक", "1 छोटा चम्मच"]],
        quick_hi: "तेल में राई, उड़द दाल, हींग, मिर्च और कढ़ी पत्ता तड़काएं|उबले चने और नमक डालकर 2 मिनट चलाएं|नारियल बुरकें"
      }
    ]
  },
  43: {
    meal_hi: "उबला अंडा काली मिर्च मसाला + चपाती",
    desc_hi: "काली मिर्च, सौंफ और भुने प्याज के मसालेदार सुखे मसाले में लिपटे उबले अंडे, चपाती के साथ।",
    state_hi: "तमिलनाडु / दक्षिण भारत",
    dishes_hi: [
      {
        name_hi: "साउथ इंडियन एग पेपर रोस्ट",
        ingredients_hi: [["उबले अंडे", "4 कटे हुए"], ["प्याज", "2 बारीक कटे"], ["कुटी काली मिर्च व सौंफ", "1.5 चम्मच"], ["हल्दी व कढ़ी पत्ता", "स्वादानुसार"], ["तेल", "1.5 चम्मच"], ["नमक", "1/2 छोटा चम्मच"]],
        quick_hi: "तेल में सौंफ, कढ़ी पत्ता और प्याज सुनहरा भूनें|हल्दी, नमक, काली मिर्च डालें|अंडे डालकर 2 मिनट मसाले में लपेटें"
      }
    ]
  },
  44: {
    meal_hi: "कुथिरावली (मिलेट) पोंगल + कीरई कूटू",
    desc_hi: "सावां बाजरा (कुथिरावली), मूंग दाल और घी-काली मिर्च का स्वास्थ्यवर्धक सुपाच्य पोंगल।",
    state_hi: "तमिलनाडु",
    dishes_hi: [
      {
        name_hi: "मिलेट वेन पोंगल",
        ingredients_hi: [["कुथिरावली (सावां बाजरा)", "1 कप"], ["मूंग दाल", "1/2 कप भुनी हुई"], ["घी", "3 बड़े चम्मच"], ["काली मिर्च, जीरा, अदरक, काजू", "तड़के के लिए"], ["नमक", "1 चम्मच"]],
        quick_hi: "मिलेट और दाल को 4 कप पानी में कुकर में पकाएं|घी में जीरा, काली मिर्च, अदरक, काजू तड़काकर मिलाएं"
      }
    ]
  },
  45: {
    meal_hi: "वेजिटेबल ओट्स उपमा + नारियल चटनी",
    desc_hi: "रोल्ड ओट्स, हरी मटर, गाजर और राई-कढ़ी पत्ते के हल्के तड़के से बना स्वादिष्ट डाइट नाश्ता।",
    state_hi: "स्वस्थ भारतीय",
    dishes_hi: [
      {
        name_hi: "हेल्दी वेजिटेबल ओट्स उपमा",
        ingredients_hi: [["रोल्ड ओट्स", "1.5 कप हल्के भुने"], ["मिक्स सब्जियां (गाजर, मटर, बीन्स)", "1 कप"], ["प्याज, हरी मिर्च, अदरक", "बारीक कटे"], ["राई, उड़द दाल, कढ़ी पत्ता", "तड़के के लिए"], ["तेल", "1 चम्मच"], ["नमक", "1 छोटा चम्मच"]],
        quick_hi: "राई, उड़द दाल, मिर्च, प्याज व सब्जियां भूनें|डेढ़ कप पानी और नमक डालकर उबालें|ओट्स डालकर 3 मिनट ढककर पकाएं"
      }
    ]
  },
  46: {
    meal_hi: "मदुरै करी डोसा (मटन कीमा डोसा)",
    desc_hi: "मदुरै का प्रसिद्ध स्पेशल करी डोसा — मोटे डोसे पर फेंटा हुआ अंडा और मसालेदार मटन कीमा बिछाकर घी में दोनों तरफ से कुरकुरा सेका हुआ।",
    state_hi: "तमिलनाडु",
    dishes_hi: [
      {
        name_hi: "मदुरै मटन कीमा सुक्का",
        ingredients_hi: [["मटन कीमा", "250 ग्राम"], ["छोटे प्याज", "1 कप"], ["अदरक-लहसुन पेस्ट", "1 चम्मच"], ["सौंफ व काली मिर्च", "1.5 चम्मच"], ["हल्दी व लाल मिर्च", "1 चम्मच"], ["तिल का तेल व कढ़ी पत्ता", "2 चम्मच"], ["नमक", "1 चम्मच"]],
        quick_hi: "तेल में सौंफ, प्याज, अदरक-लहसुन और मसाले भूनें|कीमा डालकर पानी सूखने तक 15 मिनट भूनें"
      },
      {
        name_hi: "अंडा व कीमा करी डोसा",
        ingredients_hi: [["डोसा बैटर", "2 कप"], ["अंडे", "3 फेंटे हुए"], ["शुद्ध घी", "3 चम्मच"], ["काली मिर्च व धनिया", "गार्निश"]],
        quick_hi: "तवे पर मोटा डोसा फैलाएं, ऊपर अंडा और मटन कीमा बिछाएं, घी डालकर दोनों तरफ से सुनहरा कुरकुरा सेकें"
      }
    ]
  },
  47: {
    meal_hi: "चेट्टीनाड चिकन सुक्का (कराईकुडी चिकन वरुवल)",
    desc_hi: "ताज़ा भुने चेट्टीनाड मसालों, कल्पसी, छोटे प्याज और कढ़ी पत्ते में तिल के तेल में धीमी आंच पर भुना खुशबूदार चिकन सुक्का।",
    state_hi: "तमिलनाडु",
    dishes_hi: [
      {
        name_hi: "चेट्टीनाड भुना मसाला पाउडर",
        ingredients_hi: [["साबुत धनिया व काली मिर्च", "1.5 चम्मच प्रत्येक"], ["जीरा, सौंफ, दालचीनी, लौंग", "1 चम्मच"], ["सूखी लाल मिर्च व कल्पसी", "5"]],
        quick_hi: "सारे साबुत मसालों को धीमी आंच पर भूनकर खुशबूदार पाउडर पीसें"
      },
      {
        name_hi: "चेट्टीनाड चिकन सुक्का फ्राई",
        ingredients_hi: [["चिकन", "500 ग्राम"], ["छोटे प्याज", "20 कटे हुए"], ["अदरक-लहसुन पेस्ट", "1.5 चम्मच"], ["टमाटर व कढ़ी पत्ता", "स्वादानुसार"], ["तिल का तेल", "3 चम्मच"], ["नमक व हल्दी", "1 चम्मच"]],
        quick_hi: "तेल में प्याज, अदरक-लहसुन भूनें|चिकन और पिसा चेट्टीनाड मसाला डालकर सूखा होने तक भूनें"
      }
    ]
  },
  48: {
    meal_hi: "तिरुनेलवेली हलवा (पारंपरिक गेहूं का हलवा)",
    desc_hi: "पारंपरिक सांबा गेहूं के दूध से बना शाही हलवा — शुद्ध देसी घी, कैरेमल चीनी और काजू के साथ मुंह में घुल जाने वाली बनावट।",
    state_hi: "तमिलनाडु",
    dishes_hi: [
      {
        name_hi: "सांबा गेहूं का दूध",
        ingredients_hi: [["साबुत सांबा गेहूं", "1 कप"], ["पानी", "4 कप निकालने के लिए"]],
        quick_hi: "गेहूं को 10 घंटे भिगोकर पीसें और मलमल के कपड़े से छानकर गाढ़ा दूध निकालें"
      },
      {
        name_hi: "शुद्ध घी तिरुनेलवेली हलवा",
        ingredients_hi: [["गेहूं का गाढ़ा दूध", "1 कप"], ["चीनी", "2 कप"], ["शुद्ध देसी घी", "1 कप"], ["काजू व इलायची पाउडर", "स्वादानुसार"], ["कैरेमल चीनी (रंग के लिए)", "2 चम्मच"]],
        quick_hi: "चाशनी में गेहूं का दूध डालकर लगातार चलाएं, धीरे-धीरे घी मिलाते रहें|कड़ाही छोड़ने पर भुने काजू डालकर उतारें"
      }
    ]
  }
};

export function getHindiRecipe(recipeId, fallbackRecipe) {
  if (HINDI_RECIPES[recipeId]) {
    return HINDI_RECIPES[recipeId];
  }
  const r = fallbackRecipe || {};
  return {
    meal_hi: r.meal || "",
    desc_hi: r.description || "",
    state_hi: STATE_HINDI_MAP[r.state] || r.state || "",
    dishes_hi: (r.dishes || []).map(d => ({
      name_hi: d.name,
      ingredients_hi: d.ingredients || [],
      quick_hi: d.quick || ""
    }))
  };
}

export function getHindiState(state) {
  return STATE_HINDI_MAP[state] || state;
}

export function getHindiMealTitle(recipe) {
  if (!recipe) return "";
  if (HINDI_RECIPES[recipe.id]?.meal_hi) return HINDI_RECIPES[recipe.id].meal_hi;
  return recipe.meal || "";
}

export function getHindiMealDesc(recipe) {
  if (!recipe) return "";
  if (HINDI_RECIPES[recipe.id]?.desc_hi) return HINDI_RECIPES[recipe.id].desc_hi;
  return recipe.description || "";
}
